var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.80078 6.6501C2.80078 6.0702 3.27088 5.6001 3.85078 5.6001H24.1508C24.7307 5.6001 25.2008 6.0702 25.2008 6.6501C25.2008 7.23 24.7307 7.7001 24.1508 7.7001H3.85078C3.27088 7.7001 2.80078 7.23 2.80078 6.6501ZM2.80078 14.0001C2.80078 13.4202 3.27088 12.9501 3.85078 12.9501H24.1508C24.7307 12.9501 25.2008 13.4202 25.2008 14.0001C25.2008 14.58 24.7307 15.0501 24.1508 15.0501H3.85078C3.27088 15.0501 2.80078 14.58 2.80078 14.0001ZM2.80078 21.3501C2.80078 20.7702 3.27088 20.3001 3.85078 20.3001H24.1508C24.7307 20.3001 25.2008 20.7702 25.2008 21.3501C25.2008 21.93 24.7307 22.4001 24.1508 22.4001H3.85078C3.27088 22.4001 2.80078 21.93 2.80078 21.3501Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/MenuIcon.c220944bf1f9d2afab2fa39030289d5c.svg";
export { ForwardRef as ReactComponent };